import { IChat } from '../../../../../../rest/effects/chats/chat/types';

export const getChatInitialState = (): IChat => ({
});
